import React from 'react'
import styles from './newkyc.module.css'

const newkyc = () => {
  return (
    <div>
        <div className="container-fluid">
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['kyc-card']}`}>
                        <h2 className="mb-4">KYC Form</h2>
                        <form>
                            <div className="mb-3">
                            <label className={`${styles['label-ct']} form-label`}>Entity Type <span className="text-danger ps-1">*</span></label>
                            <select className="form-select" required>
                                <option value="HUF">HUF</option>
                            </select>
                            </div>

                            

                            <div className="row">
                            <div className='col-md-6'>
                            <div className="mb-3">
                            <label className={`${styles['label-ct']} form-label`}>Address <span className="text-danger ps-1">*</span></label>
                            <input type="text" className="form-control" placeholder="4/3, 3rd floor, Sai Mango Tree" required />
                            </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className={`${styles['label-ct']} form-label`}>Country <span className="text-danger ps-1">*</span></label>
                                <input type="text" className="form-control" placeholder="India" required />
                            </div>
                            </div>

                            <div className="row">
                            <div className="col-md-4 mb-3">
                                <label className={`${styles['label-ct']} form-label`}>State <span className="text-danger ps-1">*</span></label>
                                <select className="form-select" required>
                                <option value="Karnataka">Karnataka</option>
                                </select>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className={`${styles['label-ct']} form-label`}>City <span className="text-danger ps-1">*</span></label>
                                <input type="text" className="form-control" placeholder="Bangalore" required />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className={`${styles['label-ct']} form-label`}>Pincode <span className="text-danger ps-1">*</span></label>
                                <input type="text" className="form-control" placeholder="30 LPA" required />
                            </div>
                            </div>

                            <div className='row'>
                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>Address Proof Type <span className="text-danger ps-1">*</span></label>
                            <input type="text" className="form-control" placeholder="GST Certificate" required />
                            </div>

                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>Upload Address Proof <span className="text-danger ps-1">*</span></label>
                            <input type="file" className="form-control" required />
                            </div>
                            </div>

                            <div className='row'>
                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>Name on PAN Card <span className="text-danger ps-1">*</span></label>
                            <input type="text" className="form-control" placeholder="Name" required />
                            </div>

                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>PAN Card Status <span className="text-danger ps-1">*</span></label>
                            <select className="form-select" required>
                                <option value="I have company's PAN card">I have company's PAN card</option>
                            </select>
                            </div>
                            </div>

                            <div className='row'>
                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>PAN <span className="text-danger ps-1">*</span></label>
                            <input type="text" className="form-control" placeholder="ABCD1234E" required />
                            </div>

                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>Upload PAN <span className="text-danger ps-1">*</span></label>
                            <input type="file" className="form-control" required />
                            </div>
                            </div>

                            <div className='row'>
                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>GST <span className="text-danger ps-1">*</span></label>
                            <input type="text" className="form-control" placeholder="123456789012345" required />
                            </div>

                            <div className="col-md-6 mb-3">
                            <label className={`${styles['label-ct']} form-label`}>TAN Number <span className="text-danger ps-1">*</span></label>
                            <input type="text" className="form-control" placeholder="ABC123456XYZ" required />
                            </div>
                            </div>

                            <div className="d-flex justify-content-end">
                            <button type="button" className={`${styles['cancel-btn']} btn`}>Cancel</button>
                            <button type="submit" className={`${styles['submit-btn']} btn ms-2`}>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default newkyc